import { action, thunk, computed } from 'easy-peasy'

import { FormStatus } from '@/types'

import { FeeModel, service } from '.'
import { AxiosError } from 'axios'

export const fee: FeeModel = {
	status: FormStatus.IDLE,
	data: null,
	message: '',
	error: '',

	/** Computed */
	loading: computed(state => state.status === FormStatus.LOADING),
	success: computed(state => state.status === FormStatus.SUCCESS),

	/** Actions */
	setStatus: action((state, payload) => {
		state.status = payload
	}),
	setData: action((state, payload) => {
		state.data = payload
	}),
	setMessage: action((state, payload) => {
		state.message = payload
	}),
	setError: action((state, payload) => {
		state.error = payload
	}),

	/** Thunks */
	submit: thunk(async (action, payload) => {
		try {
			action.setStatus(FormStatus.LOADING)
			const res = await service.submit(payload)
			action.setMessage(res.message)
			action.setData(res.data)
			action.setStatus(FormStatus.SUCCESS)
		} catch (e) {
			if (e instanceof AxiosError) {
				action.setStatus(FormStatus.ERROR)
				action.setError(
					e?.response?.data?.message ||
						(navigator.onLine ? 'Server Error' : 'Network Error')
				)
			}
		} finally {
			setTimeout(() => {
				action.setStatus(FormStatus.IDLE)
				action.setError('')
			}, 1)
		}
	})
}
